import styled, { css } from "styled-components";
import { Form } from "formik";
import { HTMLProps } from "react";

type TokenLinkProps = HTMLProps<HTMLAnchorElement> & {
  invalidToken?: boolean;
};

export const Container = styled.div`
  margin-top: 20px;
  h1 {
    margin-bottom: 20px;
  }
`;

export const Text = styled.p`
  color: #5e5e5e;
  font-size: 0.9375rem;
  font-weight: 400;
  margin-bottom: 20px;
`;

export const FormContainer = styled(Form)`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const TokenLink = styled.a<TokenLinkProps>`
  cursor: pointer;
  color: #074f8c !important;
  font-size: 0.875rem;
  line-height: 17px;

  ${(props) =>
    props.invalidToken &&
    css`
      color: #dc3545 !important;
    `}
`;
